import type { RouteRecordRaw } from 'vue-router';

export const releasesRoute: RouteRecordRaw = {
  path: '/releases',
  name: 'Releases',
  component: () => import('./pages/ReleasesPage.vue'),
  // Links from before releases had their own page named one release on the
  // list (`/releases?team=…&release=<id>`); they now land on that page.
  beforeEnter: (to) =>
    typeof to.query.release === 'string' && to.query.release !== ''
      ? { name: 'Release', params: { id: to.query.release }, replace: true }
      : true,
  meta: {
    title: 'Releases',
    layout: 'main',
    // Reading is in the AUTHORIZED floor, stakeholders included — the page
    // answers "did what you promised ship?", which is precisely their question.
    authorize: ({ isGranted }) => isGranted('dt:core:releases:list'),
  },
};

export const releaseRoute: RouteRecordRaw = {
  path: '/releases/:id',
  name: 'Release',
  component: () => import('./pages/ReleasePage.vue'),
  meta: {
    title: 'Release',
    layout: 'main',
    authorize: ({ isGranted }) => isGranted('dt:core:releases:list'),
  },
};
